if (!customElements.get('klaviyo-waitlist')) {
  customElements.define(
    'klaviyo-waitlist',
    class KlaviyoWaitlist extends HTMLElement {
      constructor() {
        super();

        this.productInfo = this.closest('product-info');
        this.klaviyoWaitlist = this.productInfo?.querySelector('klaviyo-waitlist');
        this.productForm = this.productInfo?.querySelector('product-form');
        this.waitlistButton = this.querySelector('.pv__waitlist');
        this.waitlistButton.addEventListener('click', this.onSubmitHandler.bind(this));
        this.waitlistEmail = this.querySelector('.product__klaviyo-email');
      }

      onSubmitHandler() {
        // check validity of email
        if (!this.waitlistEmail.checkValidity()) {
          this.waitlistEmail.reportValidity();
          return;
        }
        this.handleKlaviyoSubmit(this.productInfo, this.waitlistButton, 'Shopify Waitlist');
      }

      showSuccessState() {
        this.waitlistButton = this.querySelector('.pv__waitlist');
        // Add success class to show green background and check icon
        this.waitlistButton.classList.add('success');
      }

      toggleWaitlistButton(waitlist = true) {
        if (waitlist) {
          this.klaviyoWaitlist.classList.remove('hide');
          this.productForm.classList.add('hide');
        } else {
          this.klaviyoWaitlist.classList.add('hide');
          this.productForm.classList.remove('hide');
        }
      }

      handleKlaviyoSubmit($productInfo, $btn, klaviyoTrackName) {
        const firstName = $btn.dataset?.customerFirstName;
        const lastName = $btn.dataset?.customerLastName;
        const email = $productInfo.querySelector('.product__klaviyo-email')?.value;
        const klaviyoIdentify = {
          ['email']: `${email}`,
        };

        if (firstName) {
          klaviyoIdentify['first_name'] = `${firstName}`;
        }

        if (lastName) {
          klaviyoIdentify['last_name'] = `${lastName}`;
        }

        klaviyo.identify(klaviyoIdentify, this.myCallback($btn, klaviyoTrackName));
      }

      myCallback($el, klaviyoTrackName) {
        const {
          productName,
          variantName,
          productId,
          sku,
          categories,
          imageUrl,
          url,
          brand,
          price,
          compareAtPrice,
        } = $el.dataset;

        const item = {
          "ProductName": `${productName} - ${variantName}`,
          "ProductID": `${productId}`,
          "SKU": `${sku}`,
          "Categories": `${categories}`,
          "ImageURL": `${imageUrl}`,
          "URL": `${url}`,
          "Brand": `${brand}`,
          "Price": `${price}`,
          "CompareAtPrice": `${compareAtPrice}`,
        };
        klaviyo.track(klaviyoTrackName, item);

        this.showSuccessState();
      }
    }
  );
}
